(() => {
  'use strict';

  const root = document.documentElement;
  const moneyFormat = window.Mouvelya?.moneyFormat || '{{amount_with_comma_separator}} €';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];

  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    const formatted = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: value % 1 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(value);
    if (moneyFormat.includes('{{amount_no_decimals}}')) return `${Math.round(value).toLocaleString('fr-FR')} €`;
    return `${formatted} €`;
  };

  const setScrollLock = (locked) => {
    document.body.style.overflow = locked ? 'hidden' : '';
  };


  const setupHeader = () => {
    const header = qs('[data-site-header]');
    if (!header) return;
    const update = () => {
      const current = window.scrollY;
      header.classList.toggle('is-scrolled', current > 16);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();

    const menu = qs('[data-mobile-menu]');
    const toggle = qs('[data-menu-toggle]');
    const close = qs('[data-menu-close]');
    const setMenu = (open) => {
      if (!menu || !toggle) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      setScrollLock(open);
      if (open) close?.focus();
    };
    toggle?.addEventListener('click', () => setMenu(true));
    close?.addEventListener('click', () => setMenu(false));
    qsa('a', menu || document).forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu?.classList.contains('is-open')) setMenu(false);
    });
  };

  const setupRails = () => {
    qsa('[data-rail-section]').forEach((section) => {
      const rail = qs('[data-rail]', section);
      if (!rail) return;
      const step = () => Math.min(rail.clientWidth * 0.86, 460);
      qs('[data-rail-prev]', section)?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'auto' }));
      qs('[data-rail-next]', section)?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'auto' }));
      const progressBar = qs('[data-rail-progress]', section);
      const counter = qs('[data-rail-current]', section);
      const cards = qsa('.product-card', rail);
      let scheduled = false;
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const progress = max > 0 ? rail.scrollLeft / max : 0;
        if (progressBar) progressBar.style.transform = `scaleX(${Math.min(1, Math.max(0, progress))})`;
        if (counter && cards.length) {
          const center = rail.scrollLeft + rail.clientWidth / 2;
          let closest = 0; let distance = Infinity;
          cards.forEach((card, index) => {
            const current = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
            if (current < distance) { distance = current; closest = index; }
          });
          counter.textContent = String(closest + 1).padStart(2, '0');
        }
        scheduled = false;
      };
      rail.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  };



  const setupCompareLens = () => {
    qsa('[data-compare-lens]').forEach((lens) => {
      const range = qs('[data-compare-range]', lens);
      if (!range) return;
      const update = () => lens.style.setProperty('--compare', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    });
  };




  const setupAccordions = () => {
    qsa('[data-accordion]').forEach((group) => {
      qsa('details', group).forEach((detail) => detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        qsa('details', group).forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      }));
    });
  };

  const updateCartCount = (count) => {
    qsa('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.hidden = count < 1;
    });
  };

  const cartDrawer = qs('[data-cart-drawer]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    setScrollLock(true);
    qs('[data-cart-close]', cartDrawer)?.focus();
  };
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && cartDrawer?.classList.contains('is-open')) closeCart(); });
  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    setScrollLock(false);
  };

  const cartIcon = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12l-1 12H7L6 7Zm3 0V5a3 3 0 0 1 6 0v2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>`;
  const syncCartUpsells = (cart) => {
    const handles = new Set(cart.items.map((item) => item.handle));
    qsa('[data-cart-upsells]').forEach((group) => {
      const cards = qsa('[data-upsell-card]', group);
      cards.forEach((card) => { card.hidden = true; });
      if (!cart.item_count) {
        group.hidden = true;
        return;
      }
      const spine = cards.find((card) => card.dataset.upsellHandle === 'spine-corrector-a1');
      const chair = cards.find((card) => card.dataset.upsellHandle === 'chaise-wunda-c1');
      const recommendation = !handles.has('spine-corrector-a1') ? spine : (!handles.has('chaise-wunda-c1') ? chair : null);
      group.hidden = !recommendation;
      if (recommendation) recommendation.hidden = false;
    });
  };
  const renderCart = (cart) => {
    const body = qs('[data-cart-body]', cartDrawer || document);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = `<div class="cart-empty">${cartIcon}<p>Votre sélection est encore vide.</p><a class="button button--ghost" href="/collections/all">Découvrir la collection</a></div>`;
    } else {
      body.innerHTML = cart.items.map((item) => `<article class="drawer-item" data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image.replace(/(\.(?:jpg|jpeg|png|webp))(\?.*)?$/i, '_180x$1$2')}" width="90" height="90" alt="">` : ''}
        <div><a class="drawer-item__title" href="${item.url}">${item.product_title}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}<div class="quantity-control"><button type="button" data-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Réduire">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity + 1}" aria-label="Augmenter">+</button></div></div>
        <strong>${formatMoney(item.final_line_price)}</strong>
      </article>`).join('');
    }
    const total = qs('[data-cart-total]', cartDrawer || document);
    if (total) total.textContent = formatMoney(cart.total_price);
    updateCartCount(cart.item_count);
    syncCartUpsells(cart);
  };

  const refreshCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart refresh failed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const setupCart = () => {
    qsa('[data-cart-open]').forEach((button) => button.addEventListener('click', async () => {
      try { await refreshCart(); } catch (_) { /* Liquid drawer remains usable. */ }
      openCart();
    }));
    qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
    document.addEventListener('click', async (event) => {
      const upsellButton = event.target.closest('[data-cart-upsell-add]');
      if (!upsellButton) return;
      event.preventDefault();
      if (upsellButton.disabled) return;
      upsellButton.disabled = true;
      upsellButton.classList.add('is-loading');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(upsellButton.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Upsell add failed');
        await refreshCart();
        openCart();
        const toast = qs('[data-toast]');
        if (toast) {
          toast.textContent = 'Complément ajouté au panier';
          toast.classList.add('is-visible');
          window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
        }
      } catch (_) {
        window.location.assign('/cart');
      } finally {
        upsellButton.classList.remove('is-loading');
        upsellButton.disabled = false;
      }
    });
    cartDrawer?.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-cart-quantity]');
      if (!button) return;
      const item = button.closest('[data-line-key]');
      if (!item) return;
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.dataset.lineKey, quantity: Number(button.dataset.cartQuantity) })
        });
        if (!response.ok) throw new Error('Cart update failed');
        renderCart(await response.json());
      } catch (_) {
        window.location.assign('/cart');
      }
    });
  };

  const setupProducts = () => {
    qsa('[data-product-root]').forEach((productRoot) => {
      const form = qs('[data-product-form]', productRoot);
      const select = qs('[data-variant-select]', productRoot);
      const submit = qs('[data-product-submit]', productRoot);
      const sticky = qs('[data-sticky-atc]', productRoot);
      const stickySubmit = qs('[data-sticky-submit]', sticky || productRoot);
      const updateVariant = () => {
        const option = select?.selectedOptions?.[0];
        if (!option) return;
        const price = Number(option.dataset.price || 0);
        const compare = Number(option.dataset.compare || 0);
        const available = option.dataset.available === 'true';
        qsa('[data-current-price]', productRoot).forEach((node) => { node.textContent = formatMoney(price); });
        qsa('[data-compare-price]', productRoot).forEach((node) => {
          node.textContent = compare > price ? formatMoney(compare) : '';
          node.hidden = compare <= price;
        });
        const stickyPrice = qs('[data-sticky-price]', productRoot);
        if (stickyPrice) stickyPrice.textContent = formatMoney(price);
        if (submit) submit.disabled = !available;
        if (stickySubmit) {
          stickySubmit.disabled = !available;
          stickySubmit.textContent = available ? 'Ajouter' : 'Indisponible';
        }
        const atcText = qs('[data-atc-text]', submit || productRoot);
        if (atcText) atcText.textContent = available ? `Ajouter au panier · ${formatMoney(price)}` : 'Indisponible';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        const mediaId = option.dataset.mediaId;
        if (mediaId) { const media = qsa('[data-media-id]', productRoot).find(el => el.dataset.mediaId === mediaId); if (media) qs('[data-product-gallery]', productRoot)?.prepend(media); }
      };
      select?.addEventListener('change', updateVariant);
      updateVariant();

      const submitHandler = async (event) => {
        event.preventDefault();
        if (!submit || submit.disabled) return;
        submit.classList.add('is-loading');
        submit.disabled = true;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Ajout refusé : vérifiez la disponibilité et la quantité.');
          try { await refreshCart(); openCart(); } catch (_) { window.location.assign('/cart'); }
        } catch (_) {
          const toast = qs('[data-toast]');
          if (toast) { toast.textContent = 'Impossible de confirmer cet ajout. Vérifiez votre panier avant de réessayer.'; toast.classList.add('is-visible'); }
        } finally {
          submit.classList.remove('is-loading');
          submit.disabled = select ? select.selectedOptions[0]?.dataset.available !== 'true' : false;
        }
      };
      form?.addEventListener('submit', submitHandler);
      stickySubmit?.addEventListener('click', () => form?.requestSubmit());
      if (sticky && form && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.15 });
        observer.observe(form);
      }
    });
  };

  const setupChooser = () => {
    const form = qs('[data-chooser-form]');
    const result = qs('[data-chooser-result]');
    if (!form || !result) return;
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const values = new FormData(form);
      const foldScore = ['shared', 'store', 'light'].filter((answer) => [...values.values()].includes(answer)).length;
      const choice = foldScore >= 2 ? 'fold' : 'fixed';
      qsa('[data-result]', result).forEach((node) => { node.hidden = node.dataset.result !== choice; });
      result.hidden = false;
      result.scrollIntoView({ behavior: 'auto', block: 'center' });
    });
  };





  document.addEventListener('DOMContentLoaded', () => {
    setupHeader();
    setupRails();
    setupAccordions();
    setupCart();
    setupProducts();
    setupChooser();

    setupCompareLens();

  });
})();
